import { API } from '../../../../api/api'

export const orderServices = {
  namespaced: true,
  state: {
    list: [],
    activeServiceId: null
  },
  mutations: {
    setList(state, list) {
      state.list = list
    },
    setActiveServiceId(state, id) {
      state.activeServiceId = id
    },
  },
  actions: {
    async initList(context) {
      try {
        const response = (await API.getServicesList()).data

        context.commit(`setList`, response)

        return response
      } catch (e) {
        throw new Error('order services request error')
      }
    },
  },
  getters: {
    list(state) {
      return state.list
    },
    activeServiceId(state) {
      return state.activeServiceId
    },
    item(state) {
      if (state.activeServiceId) {
        return state.list.find(item => item.id === state.activeServiceId)
      } else {
        return null
      }
    }
  }
}
